module.exports = __webpack_public_path__ + "static/media/IMG_2510.9f5c1601.JPG";